import { payoutActionTypes } from '@Actions/payoutActions';

const PayoutReducer = (state = { }, action) => {
  switch (action.type) {
  case payoutActionTypes.GET_PO_PAYMENT.LOADING: {
    const { getPoPaymentLoading, poPaymentId } = action;
    if (poPaymentId) {
      return {
        ...state,
        selectPoPaymentLoading: getPoPaymentLoading,
      };
    }
    return {
      ...state,
      getPoPaymentLoading,
    };
  }
  case payoutActionTypes.GET_PO_PAYMENT.SUCCESS: {
    const { poPayment, poPaymentId } = action;
    if (poPaymentId) {
      return {
        ...state,
        selectedPoPayment: poPayment,
      };
    }
    return {
      ...state,
      poPayment,
    };
  }
  case payoutActionTypes.CREATE_PO_PAYMENT.LOADING: {
    const { createPoPaymentLoading } = action;
    return {
      ...state,
      createPoPaymentLoading,
    };
  }
  case payoutActionTypes.CREATE_PAYOUT_FLOW.LOADING: {
    const { createPaymentFlowLoading } = action;
    return {
      ...state,
      createPaymentFlowLoading,
    };
  }
  case payoutActionTypes.UPDATE_PAYOUT_FLOW.LOADING: {
    const { updatePaymentFlowLoading } = action;
    return {
      ...state,
      updatePaymentFlowLoading,
    };
  }
  case payoutActionTypes.CREATE_CONNECT_SESSION.LOADING: {
    const { createConnectSessionLoading } = action;
    return {
      ...state,
      createConnectSessionLoading,
    };
  }
  case payoutActionTypes.CREATE_CONNECT_SESSION.SUCCESS: {
    const { payoutSession } = action;
    return {
      ...state,
      payoutSession,
    };
  }
  case payoutActionTypes.PAYMENT_VERIFY.LOADING: {
    const { verifyPaymentLoading } = action;
    return {
      ...state,
      verifyPaymentLoading,
    };
  }
  case payoutActionTypes.PAYMENT_VERIFY.SUCCESS: {
    const { verifyPayment } = action;
    return {
      ...state,
      verifyPayment,
    };
  }
  case payoutActionTypes.CREATE_PAYMENT_SESSION.LOADING: {
    const { createPaymentSessionLoading } = action;
    return {
      ...state,
      createPaymentSessionLoading,
    };
  }
  case payoutActionTypes.CREATE_PAYMENT_SESSION.SUCCESS: {
    const { payoutSessionPayment } = action;
    return {
      ...state,
      payoutSessionPayment,
    };
  }
  case payoutActionTypes.GET_PENDING_PO_PAYMENT.LOADING: {
    const { getPendingPoPaymentLoading } = action;
    return {
      ...state,
      getPendingPoPaymentLoading,
    };
  }
  case payoutActionTypes.GET_PENDING_PO_PAYMENT.SUCCESS: {
    const { pendingPoPayment } = action;
    return {
      ...state,
      pendingPoPayment,
    };
  }
  default: {
    return state;
  }
  }
};

export default PayoutReducer;
